// import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from 'styled-components/macro'
import { PersistGate } from 'redux-persist/integration/react'

import { persistor, store } from 'state'
import { defaultTheme, GlobalStyle } from 'theme'

import App from 'pages/App'
import { ModalConductor } from 'modal'
import Updater from 'containers/Updater'
import RainbowProvider from 'containers/RainbowProvider'

// will render twice, don't worry it is only for dev mode
// https://github.com/facebook/react/issues/24467#issuecomment-1113273743
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <ThemeProvider theme={defaultTheme}>
          <RainbowProvider>
            <GlobalStyle />
            <ModalConductor />
            <Updater />
            <App />
          </RainbowProvider>
        </ThemeProvider>
      </BrowserRouter>
    </PersistGate>
  </Provider>,
)
